import { render, staticRenderFns } from "./LeaderboardHome.vue?vue&type=template&id=c1cf86c4&scoped=true&"
import script from "./LeaderboardHome.vue?vue&type=script&lang=js&"
export * from "./LeaderboardHome.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardHome.vue?vue&type=style&index=0&id=c1cf86c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf86c4",
  null
  
)

export default component.exports